import { createStore, type Store, type StoreActionApi } from 'react-sweet-state';

import type { RovoChatInitiator } from './RovoChatInitiator';

export const store: Store<
	RovoChatInitiator,
	{
		initChatInitiator: (
			initiator?: string,
		) => ({ setState, getState }: StoreActionApi<RovoChatInitiator>) => void;
		getChatInitiator: () => ({ getState }: StoreActionApi<RovoChatInitiator>) => string;
	}
> = createStore({
	initialState: { initiator: 'unknown', initiatorApplied: false } as RovoChatInitiator,
	actions: {
		initChatInitiator:
			(initiator?: string): (({ setState, getState }: StoreActionApi<RovoChatInitiator>) => void) =>
			({ setState, getState }) => {
				if (!getState().initiatorApplied) {
					setState({
						initiator: initiator ?? 'unknown',
						initiatorApplied: true,
					});
				}
			},
		getChatInitiator:
			(): (({ getState }: StoreActionApi<RovoChatInitiator>) => string) =>
			({ getState }) => {
				return getState().initiator;
			},
	},
});
